let BASE_URL = "/";

let debug = "";
if (process.env.NODE_ENV === 'development') {
    BASE_URL = `${process.env.VUE_APP_BASE_DOMAIN}`;
}

let COMMON_BASE_URL = "http://localhost/";
if (process.env.NODE_ENV === 'production') {
    COMMON_BASE_URL = "/";
}
export default {
    "APPLICANT_CHECK_AVAILABILITY": "inf-v4/api/v4/student/checkAvailability/",
    
    "APPLICANT_REGISTER_STUDENT": "inf-v4/api/v4/student/registerStudent/",
    "APPLICANT_PORTAL_RESET_PASSWORD": "inf-v4/api/v4/student/resetPasswordByEmail/",
    "APLLICANT_LOGIN_VALIDATION": "inf-v4/api/v4/student/validateApplicant/",

    "INTERNAL_FORM": "inf-v4/api/v4/form/",
    "ADMISSION_APPLICANT_APPLIED_COURSES": "adm-v3/api/v3/general/getStudentAppliedPatternCourses/",
    "GENERAL_GET_TEMPLATE_CONTENTS": "inf-v4/api/v4/general/getTemplateContents/",
    "GENERAL_GET_ALL_GENDERS": "inf-v4/api/v4/general/getAllGenders/",
    "GET_STUDENT_APPLICABLE_FORMS": "inf-v4/api/v4/form/getStudentApplicableForms",
    "INF_CURRENT_SECTION_OF_STUDENT": "inf-v4/api/v4/form/getStudentCurrentSection",
    "CREATE_INTERNAL_STUDENT_ENTRY": "inf-v4/api/v4/student/createInternalStudentEntry",
    "INF_APPLICANT_SAVED_DATA": "inf-v4/api/v4/student/getStudentAlreadySavedData",
    "SECTION_STATUS": "inf-v4/api/v4/student/student-section-status",
    "UPDATE_INTERNAL_STUDENT_ENTRY": "inf-v4/api/v4/student/updateAdmissionStudentEntry",
    "UPDATE_INTERNAL_ENQUIRY_ENTRY": "inf-v4/api/v4/student/updateAdmissionEnquiryEntry",
    "GET_PRINT_PREVIEW": "inf-v4/api/v4/student/renderStudentPrint",
    "STUDENT_GET_APPLIED_FORMS": "adm-v3/api/v3/studentPortal/getAllAppliedForms",
    "GET_SECTION_DETAILS_OF_STUDENT": "adm-v3/api/v3/studentPortal/getStudentSectionDetails",
    "INF_FORM_SECTIONS": "inf-v4/api/v4/form/section/",
    "INF_ENQUIRY_FORM_SECTIONS": "inf-v4/api/v4/form/enquiry-form-section/",
    "GET_FORM_DETAILS_BY_ID": "inf-v4/api/v4/form/getFormDetailsById/",
    "INF_INTERNAL_FORM_FIELD": "inf-v4/api/v4/form/form-field/",
    "INF_ENQUIRY_FORM_FIELD": "inf-v4/api/v4/form/enquiry-form-field/",
    "GENERAL_GET_ALL_GENERAL_SETTINGS": "inf-v4/api/v4/general/getAllGeneralSettings/",
    "GENERAL_GET_SETTINGS_BY_NAME": "inf-v4/api/v4/general/getGeneralSettingsByName/",
    "GENRATE_PAYMENT_TOKEN": "inf-v4/api/v4/internalPayment/generatePaymentToken",
    "GET_APPLICATION_FEE_CATEGORY": "inf-v4/api/v4/internalPayment/fee-category/",
    "GET_FEE_DETAILS": "inf-v4/api/v4/internalPayment/fee-details/",
    "GET_PAYMENT_DETAILS": "inf-v4/api/v4/internalPayment/payment-details/",
    "CHECK_VOUCHER_VALIDITY": "inf-v4/api/v4/internalPayment/checkVoucherValidity/",
    "UPDATE_PAYMENT_BY_VOUCHER": "inf-v4/api/v4/internalPayment/updateStudentPaymentByVoucher/",
    "UPDATE_CURRENT_SECTION_AS_ZERO": "inf-v4/api/v4/student/updateCurrentSectionAsZero/",
    "SET_VERIFIED_STATUS_TO_TWO": "adm-v3/api/v3/studentPortal/updateVerifiedStatusTo2/",

    "GET_RE_CAPTCHA_SITE_KEY": "inf-v4/api/v4/student/getReCaptchaSiteKey/",

    "GET_BANNER_PATH": "adm-v3/api/v3/studentPortal/getBannerPath/",
    "S3_CREDENTIALS_ADMISSION": "inf-v4/api/v4/general/aws-data/",
    "GENERAL_GET_COLLEGE_HEADER": "inf-v4/api/v4/student/getHeaderForCollege/",
    "INF_APPLICANT_GET_ALL_CERTIFICATES": "inf-v4/api/v4/student/fetchCertificates",
    "INF_APPLICANT_UPLOAD_CERTIFICATES": "inf-v4/api/v4/student/saveUploadedCertificates",
    "INF_APPLICANT_DELETE_CERTIFICATES": "inf-v4/api/v4/student/deleteUploadedCertificates",
    "GET_ALL_PAYMENT_STATUS": "inf-v4/api/v4/student/getAllPaymentStatus",
    "GET_APPLICANT_BASIC_DETAILS": "adm-v3/api/v3/studentPortal/getApplicantBasicDetails/",
    "ADMISSION_APPLICANT_RESET_PASSWORD_JWT_TOKEN": "adm-v3/api/v3/studentPortal/resetPasswordJwtUrl",
    "GET_STUDENT_USERNAME_WITH_TOKEN": "adm-v3/api/v3/studentPortal/resetPasswordJwtUserName/",
    "S3_SIGNATURE_GENERATOR": `${BASE_URL}common/api/v1/s3/sign-upload${debug}`,
    "S3_AWS_CONF": `common/api/v1/s3/get-s3-conf${debug}`,
    "GET_COLLEGE_DATA": "inf-v4/api/v4/general/get-college-data/",
    "S3_PRESIGNED_URL": "inf-v4/api/v4/general/s3-presigned-url/",
    "COMMON_BASE_URL": COMMON_BASE_URL,
    "REDIRECT_TO_ACADEMICS": "adm-v3/api/v3/admit/redirectToAcademics",
    "GET_ASSIGNED_PRINT_TEMPLATES": "adm-v3/api/v3/studentPortal/get-assigned-print-templates/",
    "GET_CUSTOM_PRINT_PREVIEW": "adm-v3/api/v3/studentPortal/renderStudentCustomPrint",
    "ADM_FORM_PAYMENT_COURSE_GROUP": "adm-v3/api/v3/form/adm-form-payment-course-group/",
    "GENERAL_BASIC_DETAILS_APPLICANT_AND_FORM_ID": "inf-v4/api/v4/student/getStudentBasicDetailsByFormAndApplicantId/",
    "GENERAL_ENQUIRY_BASIC_DETAILS_APPLICANT_AND_FORM_ID": "inf-v4/api/v4/student/getEnquiryStudentBasicDetailsByFormAndApplicantId/",
    "APPLY_FORM_COURSE_GROUP": "adm-v3/api/v3/studentPortal/form-course-group-apply/",
    "FETCH_MULTIPLE_PRINTS": "adm-v3/api/v3/studentPortal/fetch-multiple-prints/",
    "PRINT_ALLOTMENT_MEMO": "adm-v3/api/v3/studentPortal/print-allotment-memo/",
    "SET_COMMON_STATUS_FOR_SELECTED_STUDENTS": "adm-v3/api/v3/student/enableDisableStudentDataForStudentIdList/",

    //admission stage APIs
    "GET_STUDENT_STAGE_DETAILS": "adm-v3/api/v3/student/get-student-stage-details",
    "FORM_STAGE_DOCUMENT_DATA_PRINT": "adm-v3/api/v3/studentPortal/form-stage-document-data-print/",
    "REMARKS_FORM_FIELD": "adm-v3/api/v3/form/remarks-form-field/",
    "UPDATE_ADMISSION_REMAKS_STUDENT_ENTRY": "adm-v3/api/v3/studentPortal/updateAdmissionRemarksStudentEntry",
    "GET_REMARKS_DETAILS_OF_STUDENT": "adm-v3/api/v3/studentPortal/getStudentRemarksDetails/",
    "ADM_APPLICANT_SAVED_REMARKS_DATA": "adm-v3/api/v3/studentPortal/getStudentAlreadySavedRemarksData",
    // payment apis
    "GET_ELIGIBLE_STUDENT_COURSES_FOR_PAYMENT": "adm-v3/api/v3/student/get-student-eligible-course-for-payment",
    "GET_APPLICABLE_STUDENT_COURSE_GROUP_FOR_UG": "adm-v3/api/v3/studentPortal/student-applicable-course-group-details/",
    "GET_APPLICABLE_STUDENT_COURSE_GROUP_FOR_UG_CHILD": "adm-v3/api/v3/studentPortal/student-applicable-course-group-details-for-child/",
    "CHALLAN_PRINT": "adm-v3/api/v3/studentPortal/student-challan-print",

    "IS_STUDENT_PAID_AT_LEAST_ONCE": "inf-v4/api/v4/student/is-paid-at-least-once/",
    
    "IS_ENQUIRY_STUDENT_PAID_AT_LEAST_ONCE": "adm-v3/api/v3/studentPortal/is-paid-at-least-once-enquiry",
    "INITIATE_ALLOTMENT": "adm-v3/api/v3/admit/initiate-allotment/",
    "ALREADY_ADMITTED_STATUS": "adm-v3/api/v3/rank/already-admitted-status/",
    "STUDENT_POSITION_IN_ALLOTMENT": "adm-v3/api/v3/rank/student-position-in-allotment/",
    "GET_COMMON_SETTINGS": "adm-v3/api/v3/general/getCommonGeneralSettings/",
    "ALL_ALLOTMENT_MEMO_FOR_STUDENT": "adm-v3/api/v3/admit/all-student-pre-allotment-memo/",
    "PRINT_PREVIEW_FOR_PRE_ALLOTMENT_MEMO": "adm-v3/api/v3/studentPortal/student-pre-allotment-memo-print/",
    "GET_STUDENT_DETAILS_BEFORE_CONFIRMING": "adm-v3/api/v3/studentPortal/getStudentDetailsBeforeAllotmentConfirm",
    "UPDATE_STUDENT_DATE_BEFORE_CONFIRM": "adm-v3/api/v3/admit/update-data-before-confirm",
    "APPLICANT_AFFIDAVIT": "adm-v3/api/v3/studentPortal/applicant-affidavits/",
    "ACCEPT_AFFIDAVIT": "adm-v3/api/v3/studentPortal/accept-affidavit/",
    "GET_FORM_SPECIFIC_NOTIFICATION": "adm-v3/api/v3/studentPortal/getFormSpecificNotification/",

    "CHECK_PAYMENT_PAGE_ENABLED_FOR_STUDENT": "inf-v4/api/v4/student/check-payment-page-enabled-for-student/",
    
    "AUTO_ADMIT_ON_LAST_SECTION_SUBMIT": "adm-v3/api/v3/admit/auto-admit-on-last-section-submit/",
    "GET_ENQUIRY_FORMS": "inf-v4/api/v4/form/get-enquiry-forms/",
    "INF_ENQUIRY_FORM": "inf-v4/api/v4/form/search-enquiry-forms",
    "STUDENT_ELIGIBLE_COURSE_FOR_ADMIT": "adm-v3/api/v3/admit/student-eligible-course-for-admit/",
    "ADMIT_STUDENT_FROM_STUDENT_SIDE": "adm-v3/api/v3/admit/admit-student-from-student-list/",
    "CHECK_ALLOTMENT_PASS_ENABLE": "adm-v3/api/v3/admit/get-student-allotment-pass-enabled/",
    "PRINT_ALLOTMENT_PASS": "adm-v3/api/v3/studentPortal/print-allotment-pass/",

    "GET_OFFLINE_CERTIFICATE_ACKNOWLEDGEMENT": "adm-v3/api/v3/studentPortal/get-offline-certificate-acknowledgement/",
    "PRINT_OFFLINE_CERTIFICATE_ACKNOWLEDGEMENT": "adm-v3/api/v3/studentPortal/print-offline-certificate-acknowledgement/",
    "GET_ACADAMIC_STUDENT_DETAILS": "inf-v4/api/v4/student/get-student-details",
    "GET_STUDENT_APPLIED_FORMS": "inf-v4/api/v4/form/getStudentAppliedForms",

    // "GENERAL_GET_ALL_AVILABLE_DYNAMIC_MODULES": "inf-v4/api/v4/general/getAvilableDynamicModules/",
    "GET_DYNAMIC_MODULE_DETAILS_BY_MODULE_CODE": "inf-v4/api/v4/general/getDynamicModuleDetailsByModuleCode/",
    "GET_TEMPLATE_CONTENTS_BY_NAME_AND_MODULE_ID": "inf-v4/api/v4/general/getContentsTemplatesByNameAndModuleId/",
    "GET_STUDENT_CERTIFICATE_DETAILS":"inf-v4/api/v4/general/getStudentDetailsForCertificate/",

    "CHECK_ELIGIBILITY_OF_FORM":"inf-v4/api/v4/form/getFormIsEligibleForStudent/",


};